import { getStsQuestions, getEvaluateStage } from "@/services/sts.service";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Tüm soruların çekildiği listesi
  async loadStsQuestionList(vuexContext, co) {
    return await getStsQuestions(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
      });
      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async loadStageEvaluate(vuexContext, data) {
    return await getEvaluateStage(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
